import { render, staticRenderFns } from "./MegaCategoryList.vue?vue&type=template&id=5afc5653&"
import script from "./MegaCategoryList.vue?vue&type=script&lang=js&"
export * from "./MegaCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports